exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".shell-icon[data-v-e1b831cc]{display:inline-block;width:1em;height:1em;flex-shrink:0;vertical-align:middle}", ""]);

